(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('GroupDetailController', GroupDetailController);

    GroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Group', 'User'];

    function GroupDetailController($scope, $rootScope, $stateParams, previousState, entity, Group, User) {
        var vm = this;
       
        vm.group = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:groupUpdate', function(event, result) {
            vm.group = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
          
    }
})();
